var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOkNotSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4344 8.83059L20.4344 8.83056C20.8932 8.31421 20.8461 7.5243 20.3302 7.06523L20.3302 7.06522C19.8147 6.60658 19.0235 6.65247 18.5655 7.16902C18.5655 7.16908 18.5654 7.16914 18.5654 7.16919L11.3538 15.282L7.28073 12.0238C6.74196 11.5926 5.95454 11.6799 5.52374 12.2194C5.09263 12.7586 5.1799 13.5454 5.71891 13.9763L10.7188 17.9762L10.7192 17.9765C10.9493 18.1598 11.2251 18.25 11.4995 18.25C11.8445 18.25 12.188 18.1076 12.4343 17.8306L12.4344 17.8306L20.4344 8.83059ZM0.25 13C0.25 5.96958 5.97006 0.25 13 0.25C20.0299 0.25 25.75 5.96958 25.75 13C25.75 20.0304 20.0299 25.75 13 25.75C5.97006 25.75 0.25 20.0304 0.25 13Z",
    fill: "white",
    stroke: "#878787",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkNotSelected);
export default __webpack_public_path__ + "static/media/okNotSelected.27150b18.svg";
export { ForwardRef as ReactComponent };